import React from 'react';
import { SolicitationSection } from 'pages/project';
import { ProjectEditorContextProps } from 'pages/project/ProjectEditor/contexts/types';

const Services: React.FC<ProjectEditorContextProps> = props => {
  return <SolicitationSection requestTable {...props} />;
};

export default Services;
